import { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { getFocusDebugState, subscribeFocusTransitions } from '../tvNavigation/registry';

export function TVFocusDebugOverlay() {
    const enabled = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('tvFocusDebug') === '1';
    const [state, setState] = useState(getFocusDebugState());
    useEffect(() => {
        if (!enabled) return undefined;
        return subscribeFocusTransitions(() => setState(getFocusDebugState()));
    }, [enabled]);
    if (!enabled) return null;
    return <View pointerEvents="none" style={styles.root}>
        <Text style={styles.title}>TV FOCUS TRACE</Text>
        <Text style={styles.copy}>{state.route} · {state.modality}</Text>
        <Text style={styles.copy}>{state.activeId ?? 'no active control'}</Text>
        <Text style={styles.copy}>{state.lastTransition ? `${state.lastTransition.direction ?? state.lastTransition.reason} → ${state.lastTransition.cue}` : 'waiting for input'}</Text>
        <Text style={styles.copy}>{String((globalThis as typeof globalThis & { __JELLYFLIX_TV_FEEDBACK__?: { haptics?: string } }).__JELLYFLIX_TV_FEEDBACK__?.haptics ?? 'haptics untested')}</Text>
    </View>;
}

const styles = StyleSheet.create({
    root: { position: 'absolute', right: 16, bottom: 16, zIndex: 100000, maxWidth: 420, paddingHorizontal: 12, paddingVertical: 10, borderRadius: 8, backgroundColor: 'rgba(0,0,0,0.88)', borderWidth: 1, borderColor: '#df315b' },
    title: { color: '#df315b', fontSize: 11, fontWeight: '900', marginBottom: 4 },
    copy: { color: '#fff', fontSize: 11, lineHeight: 16 },
});
